import React, { useState } from "react";
import { Stack, Typography } from "../mui";
import type { CSSProperties, ChangeEvent } from "react";


export const AISearchHeader = (props: { onChange?, onSubmit, validationErrors?}) => {
  const [value, setValue] = useState("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    props.onChange?.(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      props.onSubmit?.(value);
    }
  };

  return (
    <Stack direction="column" alignItems="center">
      <div style={styles.wrapper}>
        <div style={styles.gradientBorder}>
          <div style={styles.inner}>
            {/* Beta badge */}
            <div style={styles.betaBadge}>Beta</div>

            <div style={styles.iconBox}>
              <span style={styles.sparkle}>✦</span>
            </div>

            <div style={styles.textContainer}>
              <span style={styles.label}>AI Powered Search</span>

              <input
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Enter Query..."
                style={styles.input}
              />
            </div>

            <div style={styles.trailing} className="ai-search-trailing">
              Smart results tailored for you
            </div>
          </div>
        </div>
      </div>
      {props.validationErrors?.[`openAI`] && (
        <Typography color="error">{props.validationErrors?.[`openAI`]}</Typography>
      )}
    </Stack>
  );
}

const styles: Record<string, CSSProperties> = {
  wrapper: {
    width: "100%",
    marginBottom: 16,
  },
  gradientBorder: {
    position: "relative",
    padding: 1,
    borderRadius: 16,
    background: "linear-gradient(90deg, #6366f1, #a855f7, #ec4899)",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
  },
  inner: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderRadius: 16,
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(8px)",
  },
  betaBadge: {
    position: "absolute",
    top: -8,
    right: 12,
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: 0.5,
    padding: "2px 6px",
    borderRadius: 999,
    background: "linear-gradient(90deg, #f59e0b, #ef4444)",
    color: "white",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    textTransform: "uppercase",
  },
  iconBox: {
    width: 36,
    height: 36,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #6366f1, #7c3aed)",
    color: "white",
    fontSize: 16,
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
  },
  sparkle: {
    display: "inline-block",
    animation: "pulse 2s infinite",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  label: {
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#6b7280",
    marginBottom: 4,
  },
  input: {
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: 14,
    fontWeight: 500,
    color: "#111827",
  },
  trailing: {
    marginLeft: "auto",
    fontSize: 12,
    color: "#9ca3af",
    display: "none",
  },
};

if (typeof document !== "undefined") {
  const styleId = "ai-search-header-keyframes";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 0.9; }
        50% { transform: scale(1.15); opacity: 1; }
        100% { transform: scale(1); opacity: 0.9; }
      }
      @media (min-width: 640px) {
        .ai-search-trailing { display: block; }
      }
    `;
    document.head.appendChild(style);
  }
}
